import { useState } from "react";

const useLiveDataTable = () => {


    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState(''); // Add search query state
    const [q, setQ] = useState(''); // Add search query state
    const [searchBy, setSearchBy] = useState('');

    // Handle page change
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Handle rows per page change
    const handlePerPageChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page); // Reset to the selected page when changing rows per page
    };

    const onSearchKeyHandler = (event) => {
        console.log("event", event.key, event.target.value);
        if (event.target.value === "") handleSearchChange(event.target.value);
        setSearchQuery(event.target.value);
        if (event.key === 'Enter') {
            handleSearchChange(event.target.value);
        }
    }

    const handleSearchBy = (params) => {
        setSearchBy(params ? params : 'type');
    }

    // Handle search query change
    const handleSearchChange = (query) => {
        setQ(query);
        setCurrentPage(1); // Reset to the first page when applying a new search
    };

    // Return all necessary data and functions to the consuming component
    return {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    };

};

export default useLiveDataTable;